import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

// Styled Components
import {
  ImageContainer,
  Img,
  NoContentContainer,
  NoContentText,
} from './index.style'

const Image =({
  urlImage,
  isTempImage,
  isEditing,
  isBase64,
  tempUrlImage,
  altImage,
  nbOfChanges,
  blur,
  opacity,
  opacityPercent,
  tradNoContent,
}) => {

  const [reloadCounter, setReloadCounter] = useState(1)

  useEffect(() => {
    setReloadCounter(previousValue => previousValue+=nbOfChanges)
  }, [urlImage, tempUrlImage, nbOfChanges])


  const getCorrectUrl = () => {
    if(isEditing && isBase64)
      return `${tempUrlImage}`  
    
    if(isTempImage)
      return `${tempUrlImage}`
    else
      return `${urlImage}`
  }

  console.log("getCorrectUrl",getCorrectUrl())
  
  return (
  <ImageContainer>
    {tempUrlImage === '' && urlImage === ''
      ? (
        <NoContentContainer>
          <NoContentText> {tradNoContent} </NoContentText>
        </NoContentContainer>
      ) : (
        <Img  
          src={getCorrectUrl()}
          alt={altImage}
          useBlur={blur}
          useOpacity={opacity}
          opacityPercent={opacityPercent}
        />
      )
    }
      
  </ImageContainer>
)}

Image.propTypes = {
  urlImage: PropTypes.string,
  isTempImage: PropTypes.bool,
  isEditing: PropTypes.bool,
  isBase64: PropTypes.bool,
  tempUrlImage: PropTypes.string,
  altImage: PropTypes.string,
  opacity: PropTypes.bool,
  opacityPercent: PropTypes.number,
  blur: PropTypes.bool,
  tradNoContent: PropTypes.string,
  nbOfChanges: PropTypes.number,
}

Image.defaultProps = {
  urlImage: '',
  isTempImage: false,
  isEditing: false,
  isBase64: false,
  tempUrlImage: '',
  altImage: '',
  opacity: false,
  opacityPercent: 0,
  blur: false,
  tradNoContent: '',
  nbOfChanges: 0,
}

export default Image